import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2, AlertTriangle } from "lucide-react";
import { Button } from "../components/ui/button";
import { api, errMsg } from "./api";

const List = ({ title, items }) => items?.length ? (
  <div>
    <div className="mb-1 font-mono text-[10px] uppercase tracking-wider text-zinc-500">{title}</div>
    <ul className="list-disc space-y-0.5 pl-4 text-xs text-zinc-300">{items.map((x) => <li key={x}>{x}</li>)}</ul>
  </div>
) : null;

export default function AssemblyNotes({ payload }) {
  const [notes, setNotes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/assembly/notes", payload);
      setNotes(data);
    } catch (e) {
      toast.error(errMsg(e, "AI notes failed"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="rounded-lg border border-zinc-800 bg-[#121215] p-4" data-testid="assembly-notes">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 font-[Manrope] font-semibold"><Sparkles className="h-4 w-4 text-amber-400" />AI assembly notes</div>
        <Button data-testid="asm-ai-notes-btn" size="sm" variant="outline" disabled={busy} onClick={run} className="border-amber-500/40 text-amber-300 hover:bg-amber-500/10 hover:text-white">
          {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Sparkles className="mr-2 h-4 w-4" />}{notes ? "Regenerate" : "Generate"}
        </Button>
      </div>
      {notes && (
        <div className="mt-4 space-y-4">
          {notes.compatibility_warnings?.map((w) => <div key={w} className="flex gap-2 rounded border border-amber-500/30 bg-amber-500/10 p-2 text-xs text-amber-200"><AlertTriangle className="h-3.5 w-3.5 shrink-0" />{w}</div>)}
          <div className="grid gap-4 lg:grid-cols-2">
            {notes.details?.map((d) => (
              <div key={d.title} className="space-y-2 rounded-md border border-zinc-800 p-3">
                <div className="text-sm font-semibold text-white">{d.title}</div>
                <List title="Sequence" items={d.sequence} />
                <List title="Fixings & seals" items={d.fixings} />
                <List title="QA checks" items={d.checks} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
